import { FieldValues, UseFormSetValue } from 'react-hook-form'

export function setFormData(
  formValues: Record<string, string | number | boolean>,
  setValue: UseFormSetValue<FieldValues>
) {
  for (const key in formValues) {
    if (formValues[key] !== undefined && formValues[key] !== null) {
      setValue?.(key, formValues[key], {
        shouldValidate: true,
        shouldDirty: true,
        shouldTouch: true,
      })
    }
  }
}
